import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

export interface SamplePoint {
  id?: string | number;
  payload?: Record<string, unknown>;
}

export interface GetSamplePointResponse {
  status?: string;
  collection?: string;
  external_id?: string;
  point_count?: number;
  points: SamplePoint[];
  detail?: string;
}

interface GetSamplePointProps {
  collectionId: string;
  externalId: string;
}

export const getSamplePoint = async ({
  collectionId,
  externalId,
}: GetSamplePointProps): Promise<GetSamplePointResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<GetSamplePointResponse>({
    url: `/collections/${orgId}/${collectionId}/points/by-external-id/${externalId}/sample`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  return (response?.data ?? response) as GetSamplePointResponse;
};
